import { useZero } from "@rocicorp/zero/react";
import { useCallback } from "react";
import { sharedMutators } from "../../shared/mutators";
import type { ChatComposerControl } from "../../shared/mutators/recordChatComposerControl";

export function useRecordChatComposerControl() {
  const z = useZero();
  return useCallback(
    (control: ChatComposerControl, value: string, chatId?: string | null) =>
      z.mutate(
        sharedMutators.recordChatComposerControl({ control, value, chatId })
      ),
    [z]
  );
}
